import { RootState } from '@src/reducers';

export const getBasePath = (state: RootState) => {
    return state.navigationContext.basePath;
};
